module.exports = function(sel, data, children, text, elm) {
  var key = data === undefined ? undefined : data.key;
  return {sel: sel, data: data, children: children,
          text: text, elm: elm, key: key};
};



/** WEBPACK FOOTER **
 ** ./~/snabbdom/vnode.js
 **/